'use client';

import { ChevronRight, RotateCcw } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/ui/tooltip';

type CompletedBannerProps = {
	onReset?: () => void;
	message?: string;
	nextDisabled?: boolean;
	onNext: () => void;
	nextLabel: string;
};

export function CompletedBanner({
	onReset,
	onNext,
	nextLabel,
	message = 'Задание выполнено.',
	nextDisabled,
}: CompletedBannerProps) {
	return (
		<div className="flex items-center justify-between gap-3 rounded-2xl border border-gray-4 bg-white px-4 py-3">
			<span className="flex items-center gap-2 text-base text-gray-3">
				{message}
			</span>
			<div className="flex shrink-0 items-center gap-2">
				{onReset && (
					<Tooltip>
						<TooltipTrigger asChild>
							<button
								type="button"
								aria-label="Пройти заново"
								onClick={onReset}
								className="flex h-9 w-9 cursor-pointer items-center gap-1.5 rounded-lg border border-gray-4 bg-white text-center text-sm font-medium text-gray-3 transition-colors hover:bg-gray-5 hover:text-black"
							>
								<RotateCcw size={16} strokeWidth={2} className="mx-auto" />
							</button>
						</TooltipTrigger>
						<TooltipContent>Пройти заново</TooltipContent>
					</Tooltip>
				)}
				<Tooltip>
					<TooltipTrigger asChild>
						<button
							type="button"
							onClick={onNext}
							disabled={nextDisabled}
							className="flex h-9 cursor-pointer items-center gap-1 rounded-lg bg-green px-5 text-sm font-medium text-white transition-colors hover:bg-green-300 disabled:cursor-not-allowed disabled:opacity-40"
						>
							{nextLabel} <ChevronRight size={16} strokeWidth={2.5} />
						</button>
					</TooltipTrigger>
					<TooltipContent>
						{nextLabel === 'К задачам'
							? 'Перейти к списку задач'
							: nextLabel === 'К курсу'
								? 'Вернуться к курсу'
								: 'Перейти к следующему заданию'}
					</TooltipContent>
				</Tooltip>
			</div>
		</div>
	);
}
